import GridContainer from '../GridContainer';
import TextLink from '../TextLink';

export default function ProjectDetails(props) {
    const roles = props.role.map((role, index) => (
        <p className="text-[#424243] dark:text-gray-300 font-semibold" key={index}>
            {role}
        </p>
    ));

    const collaborators = props.collaborators.map((people, index) => (
        <p className="text-[#424243] dark:text-gray-300 font-semibold" key={index}>
            {people}
        </p>
    ));

    let tools;
    if (props.tools) {
        tools = props.tools.map((tool, index) => (
            <p key={index} className="text-[#424243] dark:text-gray-300 font-semibold">
                {tool}
            </p>
        ));
    }

    return (
        <>
            <div className="col-start-1 col-end-7 md:col-start-5 md:col-end-7 md:mb-8">
                <p className="font-code font-light text-xl text-black dark:text-[#717179]" style={{ fontVariant: 'small-caps' }}>role</p>
                {roles}
            </div>
            <div className="col-start-7 col-end-13 md:col-start-7 md:col-end-9 md:mb-8">
                <p className="font-code font-light text-xl text-black dark:text-[#717179]" style={{ fontVariant: 'small-caps' }}>
                    {props.replaceCollab ? props.replaceCollab : 'collaborators'}
                </p>
                {collaborators}
            </div>
            <div className="col-start-1 col-end-7 mb-8 md:col-start-9 md:col-end-11">
                <p className="font-code font-light text-xl text-black dark:text-[#717179]" style={{ fontVariant: 'small-caps' }}>duration</p>
                <p className="dark:text-gray-300 font-semibold">{props.duration}</p>
            </div>
            {props.tools && (
                <div className="col-start-7 col-end-13 mb-8 md:col-start-11 md:col-end-13">
                    <p className="font-code font-light text-xl text-black dark:text-[#717179]" style={{ fontVariant: 'small-caps' }}>tools</p>
                    {tools}
                </div>
            )}
        </>
    );
}